import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import Modal from "react-modal"
import ImageOpt from "./../ImageOpt"

const ContactInfo = ({ module, siteName }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const [modalIsOpen, setIsOpen] = React.useState(false)
  const selectMicrosite = siteName + "-site"

  function openModal(data) {
    document.body.classList.add("modal-open")
    document.body.classList.add(selectMicrosite)
    setIsOpen(true)
  }

  function closeModal() {
    document.body.classList.remove("modal-open")
    document.body.classList.remove(selectMicrosite)
    setIsOpen(false)
  }

  const zigzagmodal = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0",
      border: "0",
      borderRadius: "0",
      width: "100%",
      height: "100%",
      background: "trasnsparent",
    },
    overlay: {
      zIndex: "99",
    },
  }

  const [isLadoing, setIsLoading] = useState(false)
  const [form, setForm] = useState({
    input_1: "",
    input_5: "",
    input_3: "",
    input_4: "",
    input_6: siteName,
  })

  const [formError, setFormError] = useState({
    input_5: "",
    input_3: "",
    input_4: "",
    input_6: "",
  })

  const showNewsletterThankYouMessage = () => {
    const divElement = document.querySelector(".formContactData")
    divElement.innerHTML = ""
    const buttonElement = document.querySelector(".formContactButton")
    buttonElement.innerHTML = ""
    const infoElement = document.querySelector(".formContactInfo")
    infoElement.innerHTML = ""
    const newsletterFormWrapper = document.querySelector(".contact-form")
    const paragraph = document.createElement("p")
    paragraph.classList.add("newsletter-message")
    paragraph.innerText = "Thank you for signing up to our newsletter!"
    newsletterFormWrapper.appendChild(paragraph)
  }

  if (module.hideSection === "no") {
    return (
      <section
        initial="hidden"
        animate={isInView || hasPlayed ? "show" : "hidden"}
        variants={sectionShow}
        className={`contact content-grid ${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <div className="container-fluid">
          <div className="bg-white-100 py-60 lgscreen:py-30 lgscreen:pb-30">
            <motion.div
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
            >
              <motion.div
                ref={ref}
                initial="hidden"
                animate={isInView || hasPlayed ? "show" : "hidden"}
                variants={sectionShow}
              >
                <div className="top-content relative w-full max-w-[960px] px-20 mx-auto text-center">
                  {module?.heading && (
                    <motion.h2 variants={animFade}>{module.heading}</motion.h2>
                  )}
                  {module?.description && (
                    <motion.div variants={animFade} className="content pb-30">
                      {parse(module.description)}
                    </motion.div>
                  )}
                </div>
                <div className="accordian-container accordian-content mt-50 lgscreen:mt-25 px-80 lgscreen:px-40 ipad:px-30 relative">
                  <div className="flex flex-wrap items-center">
                    {module?.mapIframe && (
                      <motion.div
                        variants={animFade}
                        className={`lg:w-6/12 w-full ${
                          module?.mapPosition === "right"
                            ? "order-2 lgscreen:order-1"
                            : ""
                        } `}
                      >
                        <div className="map relative">
                          {parse(module.mapIframe)}
                        </div>
                      </motion.div>
                    )}
                    <div
                      className={`lg:w-6/12 w-full ${
                        module?.mapPosition === "right"
                          ? "order-1 lgscreen:order-2"
                          : ""
                      }`}
                    >
                      <div
                        className={`zigzag-content laptop:px-40 lgscreen:px-0 lgscreen:pt-30 ${
                          module?.mapPosition === "right"
                            ? "pr-75 pl-40"
                            : "pl-75 pr-40"
                        }`}
                      >
                        {module?.contactTitle && (
                          <motion.h3 variants={animFade}>
                            {module.contactTitle}
                          </motion.h3>
                        )}
                        {module?.contactDescription && (
                          <motion.div
                            variants={animFade}
                            className="content py-5"
                          >
                            {parse(module.contactDescription)}
                          </motion.div>
                        )}
                        {module?.contactPhone && (
                          <motion.div
                            variants={animFade}
                            className="flex flex-wrap gap-x-2 pt-5"
                          >
                            <div className="w-[15px] flex justify-center">
                              <img
                                src="../../../images/phone.svg"
                                width={12}
                                height={12}
                                loading="lazy"
                                alt="Arrow"
                              />
                            </div>
                            <Link
                              to={`tel: ${module.contactPhone}`}
                              className="font-ositalic normal-case underline hover:opacity-50"
                            >
                              {module.contactPhone}
                            </Link>
                          </motion.div>
                        )}
                        {module?.contactMail && (
                          <motion.div
                            variants={animFade}
                            className="flex flex-wrap gap-x-2 pt-5"
                          >
                            <div className="w-[15px] flex justify-center">
                              <img
                                src="../../../images/email.svg"
                                width={15}
                                height={15}
                                loading="lazy"
                                alt="Arrow"
                              />
                            </div>
                            <Link
                              to={`mailto: ${module.contactMail}`}
                              className="font-ositalic normal-case underline hover:opacity-50"
                            >
                              {module.contactMail}
                            </Link>
                          </motion.div>
                        )}
                        {module?.contactAddress && (
                          <motion.div
                            variants={animFade}
                            className="flex flex-wrap items-start gap-x-2 pt-5"
                          >
                            <div className="w-[15px] flex justify-center">
                              <img
                                src="../../../images/location-black.svg"
                                width={15}
                                height={15}
                                loading="lazy"
                                alt="Arrow"
                                className="relative top-2"
                              />
                            </div>
                            <div className="grid leading-18 lgscreen:w-[calc(100%_-_25px)]">
                              <span className="font-ositalic text-13 contect-addinfo">
                                {parse(module.contactAddress)}
                              </span>
                              <Link
                                to={module.googleMapLink.url}
                                className="font-ositalic normal-case underline mt-10 hover:opacity-50"
                                target={module.googleMapLink.target}
                              >
                                View on Google Maps
                              </Link>
                            </div>
                          </motion.div>
                        )}

                        <motion.div
                          variants={animFade}
                          className="mediaenquiries border-t-1 border-charcoal pt-20 mt-30"
                        >
                          {module?.mediaTitle && (
                            <motion.h6
                              variants={animFade}
                              className="text-[20px] uppercase"
                            >
                              {module.mediaTitle}
                            </motion.h6>
                          )}
                          {module?.mediaMail && (
                            <motion.div variants={animFade}>
                              <div className="flex flex-wrap gap-x-2 pt-5">
                                <img
                                  src="../../../images/email.svg"
                                  width={15}
                                  height={15}
                                  loading="lazy"
                                  alt="Arrow"
                                />
                                <Link
                                  to={`mailto: ${module.mediaMail}`}
                                  className="font-ositalic normal-case hover:opacity-50 halfunderline relative"
                                >
                                  {module.mediaMail}
                                </Link>
                              </div>
                            </motion.div>
                          )}
                          {module?.viewInPress && (
                            <motion.div
                              variants={animFade}
                              className="flex pl-[26px]"
                            >
                              <Link
                                to={module.viewInPress.url}
                                target={module.viewInPress.target}
                                className="font-ositalic normal-case underline hover:opacity-50"
                              >
                                {module.viewInPress.title}
                              </Link>
                            </motion.div>
                          )}
                        </motion.div>
                        <div className="flex flex-wrap gap-x-2 mt-35 lgscreen:mt-15 gap-y-2">
                          {module?.bookNow && (
                            <motion.div
                              variants={animFade}
                              className="smscreen:w-full"
                            >
                              <Link
                                to={module.bookNow.url}
                                className="btn btn-black"
                                target={module.bookNow.target}
                              >
                                {module.bookNow.title}
                              </Link>
                            </motion.div>
                          )}
                          <motion.div
                            variants={animFade}
                            className="smscreen:w-full"
                          >
                            <button
                              className="btn btn-border"
                              onClick={() => {
                                openModal()
                              }}
                            >
                              sign up for newsletter
                            </button>
                          </motion.div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Modal
                  isOpen={modalIsOpen}
                  style={zigzagmodal}
                  onRequestClose={closeModal}
                  ariaHideApp={false}
                  id="newsletter-site-form"
                >
                  <div className="zigzag-modal-popup relative  m-80 h-[calc(100%_-_100px)] lgscreen:h-auto lgscreen:m-30 bg-white-100 ">
                    <button
                      onClick={closeModal}
                      className="absolute right-50 top-50 z-9 lgscreen:right-30 lgscreen:top-30 lgscreen:bg-white-100 lgscreen:rounded-100  flex items-center justify-center w-[40px] h-[40px] rounded-100"
                    >
                      <img
                        src="../../../images/close.svg"
                        className="absolute top-50per left-50per translate-x-minus_50 translate-y-minus_50"
                        width={15}
                        height={15}
                        loading="lazy"
                        alt="closebtn"
                      />
                    </button>
                    <div className="flex flex-wrap items-center h-full">
                      <div className="lg:w-5/12 w-full h-full mdscreen:h-auto relative">
                        {module?.popupImage && (
                          <div className="img h-full">
                            <ImageOpt
                              imgData={module.popupImage.mediaItemUrl}
                              width={680}
                              height={767}
                              imgAlt={module.popupImage.altText}
                              imgLoad="lazy"
                              imgClass="w-full h-full object-cover"
                            />
                          </div>
                        )}
                      </div>
                      <div className="lg:w-7/12 w-full lgscreen:mb-30">
                        <div className="px-100 laptop:px-50 lgscreen:px-20 lgscreen:py-30">
                          {module?.popupPreHeading && (
                            <div className="preheading mb-5 lgscreen:mb-15">
                              <span className="font-ositalic text-16 text-charcoal">
                                {module.popupPreHeading}
                              </span>
                            </div>
                          )}
                          {module?.popupHeading && (
                            <h3>{module.popupHeading}</h3>
                          )}
                          {module?.popupDescription && (
                            <div className="content pt-10">
                              {parse(module.popupDescription)}
                            </div>
                          )}
                          <div className="gform_wrapper mt-10 w-[350px] smscreen:w-full">
                            <div className="gform_body">
                              <ul className="flex flex-wrap justify-between smscreen2:flex-col -mx-20 smscreen2:mx-0 formContactData">
                                <input
                                  type="hidden"
                                  value={siteName}
                                  placeholder="Type here"
                                  onChange={e => {
                                    setForm({
                                      ...form,
                                      input_6: e.target.value,
                                    })
                                  }}
                                />

                                <li className="w-full">
                                  <label
                                    className="text-12 tracking-05em uppercase"
                                    htmlFor="input_3"
                                  >
                                    name{" "}
                                    <span className="text-[#CE0D0D]">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    value={form.input_3}
                                    placeholder="Type here"
                                    onChange={e => {
                                      setForm({
                                        ...form,
                                        input_3: e.target.value,
                                      })
                                      setFormError({
                                        ...formError,
                                        input_3: "",
                                      })
                                    }}
                                  />
                                  {formError.input_3 && (
                                    <div className="error">
                                      <span className="text-red">
                                        {formError.input_3}
                                      </span>
                                    </div>
                                  )}
                                </li>
                                <li className="w-full">
                                  <label
                                    className="text-12 tracking-05em uppercase"
                                    htmlFor="input_4"
                                  >
                                    Surname{" "}
                                    <span className="text-[#CE0D0D]">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    value={form.input_4}
                                    placeholder="Type here"
                                    onChange={e => {
                                      setForm({
                                        ...form,
                                        input_4: e.target.value,
                                      })
                                      setFormError({
                                        ...formError,
                                        input_4: "",
                                      })
                                    }}
                                  />
                                  {formError.input_4 && (
                                    <div className="error">
                                      <span className="text-red">
                                        {formError.input_4}
                                      </span>
                                    </div>
                                  )}
                                </li>
                                <li className="w-full">
                                  <label
                                    className="text-12 tracking-05em uppercase"
                                    htmlFor="input_5"
                                  >
                                    Email Address{" "}
                                    <span className="text-[#CE0D0D]">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    value={form.input_5}
                                    onBlur={e => {
                                      var value = e.target.value
                                      var pattern =
                                        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                                      if (!pattern.test(value)) {
                                        setForm({ ...form, input_5: "" })
                                        setFormError({
                                          ...formError,
                                          input_5: "Please enter valid email.",
                                        })
                                      }
                                    }}
                                    onChange={e => {
                                      setForm({
                                        ...form,
                                        input_5: e.target.value,
                                      })
                                      setFormError({
                                        ...formError,
                                        input_5: "",
                                      })
                                    }}
                                    placeholder="Email Address"
                                  />

                                  {formError.input_5 && (
                                    <div className="error">
                                      <span className="text-red">
                                        {formError.input_5}
                                      </span>
                                    </div>
                                  )}
                                </li>
                              </ul>
                              <div className="flex flex-wrap gap-x-[3px] formContactInfo">
                                <span className="text-[9px] text-charcoal opacity-50">
                                  *
                                </span>
                                <span className="text-[9px] text-charcoal opacity-50">
                                  By signing up for this newsletter you are
                                  consenting to receiving emails from <br /> the
                                  full Kove Collection of properties
                                </span>
                              </div>
                              <div className="mt-30 formContactButton">
                                <button
                                  type="submit"
                                  className="btn btn-black cursor-pointer"
                                  onClick={() => {
                                    var validRegex =
                                      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                                    setFormError({
                                      ...formError,
                                      input_4:
                                        form.input_4 === ""
                                          ? "Please enter Surname."
                                          : "",
                                      input_3:
                                        form.input_3 === ""
                                          ? "Please enter Name."
                                          : "",
                                      input_5:
                                        form.input_5 === "" ||
                                        !form.input_5.match(validRegex)
                                          ? "Please enter valid email."
                                          : "",
                                    })

                                    if (
                                      form.input_4 !== "" &&
                                      form.input_3 !== "" &&
                                      form.input_5 !== ""
                                    ) {
                                      document.body.classList.add("loader")
                                      setIsLoading(true)
                                      const requestOptions = {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify(form),
                                      }
                                      const url = `${process.env.GATSBY_SITE_URL}wp-json/gf/v2/forms/${process.env.GATSBY_MICROSITE_NEWSLETTER_FORM_ID}/submissions`
                                      setFormError({
                                        ...formError,
                                      })
                                      fetch(url, requestOptions).then(
                                        response => {
                                          if (response.status === 200) {
                                            document.body.classList.remove(
                                              "loader"
                                            )
                                            setIsLoading(false)
                                            showNewsletterThankYouMessage()
                                          } else {
                                            setFormError({
                                              ...formError,
                                            })
                                          }
                                        }
                                      )
                                    }
                                  }}
                                >
                                  {isLadoing ? "Loading" : "Sign Up"}
                                </button>
                              </div>

                              <div className="contact-form mt-10"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    )
  }
  return null
}

export default ContactInfo
export const EatDrinkContactInfoFragment = graphql`
  fragment EatDrinkContactInfoFragment on WpEatDrink_Restaurantcontent_RestaurantContent_ContactInfo {
    extraId
    extraClass
    hideSection
    mapPosition
    heading
    mapIframe
    mediaMail
    mediaTitle
    popupDescription
    popupHeading
    popupPreHeading
    contactDescription
    contactTitle
    description
    bookNow {
      target
      title
      url
    }
    contactMail
    contactPhone
    contactAddress
    googleMapLink {
      target
      title
      url
    }
    viewInPress {
      target
      title
      url
    }
    popupImage {
      altText
      mediaItemUrl
    }
  }
`
